<template>
    <div>
        <div class="portal-tab-div profile">
            <!-- Profile Section -->
            <div class="text-block-925">Manage Account<br></div>
            <div class="line-divider-div"></div>
            <div class="text-block-926">Your Profile<br></div>
            <div class="form-block-14 w-form">
                <form id="profile-form" @submit.prevent="updateDetails">
                    <!-- Name Fields -->
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="First-Name" class="field-label-2">First Name</label>
                            <input 
                                class="portal-input w-input" 
                                maxlength="256" 
                                v-model="profileUser.first_name" 
                                type="text" 
                                id="First-Name" 
                                required>
                        </div>
                        <div class="input-div-half">
                            <label for="Last-Name" class="field-label-2">Last Name</label>
                            <input 
                                class="portal-input w-input" 
                                maxlength="256" 
                                v-model="profileUser.last_name" 
                                type="text" 
                                id="Last-Name" 
                                required>
                        </div>
                    </div>
    
                    <!-- Email and Phone Fields -->
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="Email" class="field-label-2">Email</label>
                            <input 
                                class="portal-input w-input" 
                                maxlength="256" 
                                v-model="profileUser.email" 
                                type="email" 
                                id="Email" 
                                required>
                        </div>
                        <div class="input-div-half">
                            <label for="Phone" class="field-label-2">Phone Number</label>
                            <div class="phone-entry-div felix">
                                <input 
                                    class="phone-number-field-3 _1 form w-input" 
                                    v-model="phonePartOne" 
                                    @input="updatePhone"
                                    maxlength="3" 
                                    placeholder="(000)" 
                                    type="text" 
                                    required>
                                <div class="text-block-539">-</div>
                                <input 
                                    class="phone-number-field-3 form w-input"   
                                    v-model="phonePartTwo" 
                                    @input="updatePhone"
                                    maxlength="3" 
                                    placeholder="000" 
                                    type="text" 
                                    required>
                                <div class="text-block-539">-</div>
                                <input 
                                    class="phone-number-field-3 _2 form w-input"  
                                    v-model="phonePartThree" 
                                    @input="updatePhone"
                                    maxlength="4" 
                                    placeholder="0000" 
                                    type="text" 
                                    required>
                            </div>
                            <label class="w-checkbox">
                                <input 
                                    type="checkbox" 
                                    v-model="profileUser.text_updates" 
                                    class="w-checkbox-input">
                                <span class="checkbox-label-20 w-form-label">Text me with news and offers</span>
                            </label>
                        </div>
                    </div>
    
                    <!-- Gender and Weight Fields -->
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="gender" class="field-label-2">Gender at Birth</label>
                            <select 
                                class="portal-input w-input" 
                                id="gender" 
                                v-model="profileUser.gender" 
                                required>
                                <option value="Female">Female</option>
                                <option value="Male">Male</option>
                            </select>
                        </div>
                        <div class="input-div-half">
                            <label for="Weight" class="field-label-2">Weight in Pounds (Lbs.)</label>
                            <input 
                                class="portal-input w-input" 
                                v-model.number="profileUser.weight"
                                type="number"
                                inputmode="numeric"
                                id="Weight" 
                                min="1"
                                max="999"
                                required>
                        </div>
                    </div>
    
                    <!-- Height Fields -->
                    <div class="field-label-2">Height in Feet &amp; Inches</div>
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <input 
                                class="portal-input w-input" 
                                type="number"
                                inputmode="numeric"
                                v-model.number="heightFeet"
                                @input="updateHeight"
                                placeholder="Feet" 
                                min="0" 
                                max="8" 
                                required>
                        </div>
                        <div class="input-div-half">
                            <input 
                                class="portal-input w-input" 
                                type="number"
                                inputmode="numeric"
                                v-model.number="heightInches"
                                @input="updateHeight"
                                placeholder="Inches" 
                                min="0" 
                                max="11" 
                                required>
                        </div>
                    </div>
    
                   
    
                    <input 
                        type="submit" 
                        class="submit-button-14 w-button" 
                        value="Update"
                        style="color:#fff"
                        :disabled="updating">
                </form>
    
                <!-- Form Status Messages -->
                <div v-if="showSuccessMessage" class="w-form-done" style="display: block;">
                    <div>Thank you! Your profile has been updated!</div>
                </div>
                <div v-if="showErrorMessage" class="w-form-fail" style="display: block;">
                    <div>{{ errorMessage }}</div>
                </div>
            </div>
    
            <!-- Shipping Address Section -->
            <div class="line-divider-div"></div>
            <div class="text-block-926">Shipping Address<br></div>
             <div class="w-form">
                <form id="address-form" @submit.prevent="updateAddress">
                    <div class="address-split">
                    <div class="address-div">
                            <input class="tf_textfield-3 w-input" v-model="addressForm.address_line_1" maxlength="256" name="Address-1" data-name="Address 1" placeholder="Address" type="text" id="Address-2" required>
                    </div>
                    <div class="apt-div">
                        <input class="tf_textfield-3 w-input" maxlength="256" v-model="addressForm.address_line_2" name="Apt-2" data-name="Apt 2" placeholder="Apt #" type="text" id="Apt-2">
                    </div>
                    </div>
                    <div class="address-split">
                        <input v-model="addressForm.city" class="tf_textfield-3 w-input" placeholder="City" style="width:33%" required/>
                        <select id="State-4" name="State-4" data-name="State 4" required v-model="addressForm.state"  class="tf_textfield-3 w-input" style="width:33%">
                            <option value="" disabled selected>State...</option>
                            <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                        </select>
                        <input v-model="addressForm.zip" placeholder="ZIP Code" class="tf_textfield-3 w-input" style="width:30%;margin-left: 5px;" required/>
                    </div>
                    <input 
                        type="submit" 
                        class="submit-button-14 w-button" 
                        value="Update Address"
                        style="color:#fff"
                        :disabled="updating">

                        <div v-if="showAddressSuccess"  style="display: block;">
                            <div>Address updated successfully!</div>
                        </div>
                        <div v-if="showAddressError" style="display: block;">
                            <div>{{ addressErrorMessage }}</div>
                        </div>
                </form>
                
            </div>
    
            <!-- Password Update Section -->
            <div class="line-divider-div"></div>
            <div class="text-block-926">Update Password<br></div>
            <div class="w-form">
                <form id="password-form" @submit.prevent="updatePassword">
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="new-password" class="field-label-2">New Password</label>
                            <input 
                                class="portal-input w-input" 
                                type="password" 
                                id="new-password"
                                v-model="passwordForm.newPassword"
                                required>
                        </div>
                        <div class="input-div-half">
                            <label for="confirm-password" class="field-label-2">Reenter Password</label>
                            <input 
                                class="portal-input w-input" 
                                type="password" 
                                id="confirm-password"
                                v-model="passwordForm.confirmPassword"
                                required>
                        </div>
                    </div>
                    <input 
                        type="submit" 
                        class="submit-button-14 w-button" 
                        value="Update Password"
                        style="color:#fff"
                        :disabled="updating">
                </form>
                <div v-if="showPasswordSuccess" class="w-form-done" style="display: block;">
                    <div>Password updated successfully!</div>
                </div>
                <div v-if="showPasswordError" class="w-form-fail" style="display: block;">
                    <div>{{ passwordErrorMessage }}</div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    //import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
    import state from "@/utils/state.json"
    export default {
        name: 'ProfilePage',
    
        components: {
            //GooglePlacesAutocomplete
        },
    
        props: {
            user: {
                type: Object,
                required: true
            },
            baseUrl: {
                type: String,
                required: true
            }
        },
    
        data() {
            return {
                allState: state,
                googleMapsApiKey: process.env.VUE_APP_GOOGLE_KEY,
                updating: false,
                showSuccessMessage: false,
                showErrorMessage: false,
                showAddressSuccess: false,
                showAddressError: false,
                showPasswordSuccess: false,
                showPasswordError: false,
                errorMessage: '',
                addressErrorMessage: '',
                passwordErrorMessage: '',
                profileUser: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    gender: '',
                    weight: '',
                    height_inch: 0,
                    text_updates: false,
                    preferred_categories: []
                },
                phonePartOne: '',
                phonePartTwo: '',
                phonePartThree: '',
                heightFeet: 0,
                heightInches: 0,
                categories: ['MIND', 'BODY', 'WEIGHT', 'SEX', 'LONGEVITY', 'SKIN', 'HAIR'],
                passwordForm: {
                    newPassword: '',
                    confirmPassword: ''
                },
                addressForm: {
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zip: ''
                }
            }
        },
    
        methods: {
            updatePhone() {
                this.phonePartOne = this.phonePartOne.replace(/\D/g, '').slice(0, 3)
                this.phonePartTwo = this.phonePartTwo.replace(/\D/g, '').slice(0, 3)
                this.phonePartThree = this.phonePartThree.replace(/\D/g, '').slice(0, 4)
                this.profileUser.phone = `${this.phonePartOne}${this.phonePartTwo}${this.phonePartThree}`
            },
    
            updateHeight() {
                const feet = parseInt(this.heightFeet) || 0
                const inches = parseInt(this.heightInches) || 0
                
                if (inches >= 12) {
                    this.heightInches = 11
                }
                
                this.profileUser.height_inch = (feet * 12) + parseInt(this.heightInches)
            },
    
            initializePhoneParts() {
                if (this.profileUser.phone) {
                    this.phonePartOne = this.profileUser.phone.slice(0, 3)
                    this.phonePartTwo = this.profileUser.phone.slice(3, 6)
                    this.phonePartThree = this.profileUser.phone.slice(6, 10)
                }
            },
    
            initializeHeightParts() {
                const totalInches = parseInt(this.profileUser.height_inch) || 0
                this.heightFeet = Math.floor(totalInches / 12)
                this.heightInches = totalInches % 12
            },
    
            isSelectedCategory(category) {
                return this.profileUser.preferred_categories.includes(category)
            },
    
            toggleCategory(category) {
                const index = this.profileUser.preferred_categories.indexOf(category)
                if (index === -1) {
                    this.profileUser.preferred_categories.push(category)
                } else {
                    this.profileUser.preferred_categories.splice(index, 1)
                }
            },
    
            async updateDetails() {
                this.clearMessages()

                // Validate form before proceeding
                if (!this.validateForm()) {
                    return
                }
                if (this.profileUser.phone && this.profileUser.phone.length !== 10) {
                    this.showError('Please enter a valid 10-digit phone number')
                    return
                }
    
                try {
                    this.updating = true
                    this.clearMessages()
                    
                    // Emit update event to parent
                    let response = await this.$axios.post(`${this.baseUrl}/api/update-profile`, this.profileUser)
                    if(response.data.status==='success'){
                        await this.$store.dispatch('UpdateUserData', this.profileUser)
                        this.showSuccessMessage = true
                       
                        setTimeout(() => {
                            this.showSuccessMessage = false
                        }, 3000)
                    }
                    
                } catch (error) {
                    this.showError(error.message || 'Failed to update profile')
                } finally {
                    this.updating = false
                }
            },
    
            async updatePassword() {
                if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
                    this.passwordErrorMessage = 'Passwords do not match'
                    this.showPasswordError = true
                    return
                }
    
                try {
                    this.updating = true
                    this.clearMessages()
                    
                    // Emit password update event to parent
                    let response = await this.$axios.post(`${this.baseUrl}/api/update-password`, this.passwordForm)
                    if(response.data.status==='success'){
                        this.showPasswordSuccess = true
                        setTimeout(() => {
                            this.showPasswordSuccess = false
                        }, 3000)
                    }
                } catch (error) {
                    this.passwordErrorMessage = error.message || 'Failed to update password'
                    this.showPasswordError = true
                } finally {
                    this.updating = false
                }
            },
    
            getAddressData(address) {
                this.addressForm = {
                    address_line_1: address.street,
                    address_line_2: address.address_line2,
                    city: address.city,
                    state: address.state,
                    zip: address.zip
                }
            },
            isValidUSState(state) {
                const regex = /^(A[LKZR]|C[AOT]|D[EC]|FL|GA|HI|I[ADLN]|K[SY]|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY)$/;
                return regex.test(state.toUpperCase());
            },
            async updateAddress() {
                try {
                    if(!this.isValidUSState(this.addressForm.state)){
                        this.addressErrorMessage = "State should be 2 Char long . Example CA , FL"
                        this.showAddressError= true;
                        return false;
                    }
                    this.updating = true
                    this.clearMessages()
                    
                    // Emit address update event to parent
                    let response = await this.$axios.post(`${this.baseUrl}/api/ship-address`, this.addressForm)
                    if(response.data.status==='success'){
                        await this.$store.dispatch('saveShippingDetails',this.addressForm);
                        this.showAddressSuccess = true
                        setTimeout(() => {
                            this.showAddressSuccess = false
                        }, 3000)
                    }
                    this.updating = false
                } catch (error) {
                this.addressErrorMessage = error.message || 'Failed to update address'
                this.showAddressError = true;
                this.updating = false
            }
        },

        showError(message) {
            this.errorMessage = message
            this.showErrorMessage = true
            setTimeout(() => {
                this.showErrorMessage = false
                this.errorMessage = ''
            }, 3000)
        },

        clearMessages() {
            this.showSuccessMessage = false
            this.showErrorMessage = false
            this.showAddressSuccess = false
            this.showAddressError = false
            this.showPasswordSuccess = false
            this.showPasswordError = false
            this.errorMessage = ''
            this.addressErrorMessage = ''
            this.passwordErrorMessage = ''
        },

        validateForm() {
            // Basic form validation
            if (!this.profileUser.first_name || !this.profileUser.last_name) {
                this.showError('Please enter your full name')
                return false
            }

            if (!this.profileUser.email || !this.validateEmail(this.profileUser.email)) {
                this.showError('Please enter a valid email address')
                return false
            }

            if (!this.profileUser.phone || this.profileUser.phone.length !== 10) {
                this.showError('Please enter a valid 10-digit phone number')
                return false
            }

            if (!this.profileUser.gender) {
                this.showError('Please select your gender')
                return false
            }

            if (!this.profileUser.weight || this.profileUser.weight < 1) {
                this.showError('Please enter a valid weight')
                return false
            }

            if (this.profileUser.height_inch < 1) {
                this.showError('Please enter a valid height')
                return false
            }

            return true
        },

        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return re.test(email)
        },
        async checkShippingAddress(){
            if(this.$store.getters.shipping==null){
                //get shipping 
                let response = await this.$axios.get(`${this.baseUrl}/api/ship-address`, this.addressForm)
                if(response.data.shipping!=null){
                    this.addressForm.address_line_1= response.data.shipping.address_line_1;
                    this.addressForm.address_line_2=response.data.shipping.address_line_2;
                    this.addressForm.city=response.data.shipping.city;
                    this.addressForm.state=response.data.shipping.state;
                    this.addressForm.zip=response.data.shipping.zip;
                    this.$store.dispatch('saveShippingDetails',response.data.shipping);
                }
            }else{
                this.addressForm = this.$store.getters.shipping;
            }
        },
        initializeProfile() {
            // Deep copy of user data to avoid direct mutation
            this.profileUser = JSON.parse(JSON.stringify(this.user))
            
            // Initialize phone parts
            this.initializePhoneParts()
            
            // Initialize height parts
            this.initializeHeightParts()
            
            // Initialize preferred categories if not present
            if (!this.profileUser.preferred_categories) {
                this.profileUser.preferred_categories = []
            }
            
            // Initialize text updates if not present
            if (typeof this.profileUser.text_updates === 'undefined') {
                this.profileUser.text_updates = false
            }
        }
    },

    watch: {
        user: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.initializeProfile()
                }
            }
        }
    },

    created() {
        this.initializeProfile();
        this.checkShippingAddress();
    }
}
</script>
<style scoped>
.link-block-71.mind23 {
    background-color: var(--mind);
}
.link-block-71.weight23 {
    background-color: var(--weight);
}
.link-block-71.body23 {
    background-color: var(--body);
}
.link-block-71.sex23 {
    background-color: var(--sex);
}
.link-block-71.skin23 {
    background-color: var(--skin);
}
.link-block-71.hair23 {
    background-color: var(--hair);
}
.link-block-71.longevity23 {
    background-color: var(--longevity);
}
</style>
